/**
 * our loading component
 * @return {JSX.Element} our loading component
 */
export const Loading = () => <p>Loading...</p>;
